var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOutOfStock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none",
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4D4D4D",
    fillRule: "evenodd",
    d: "M14 4.55c-5.22 0-9.45 4.23-9.45 9.45 0 5.219 4.23 9.45 9.45 9.45 5.219 0 9.45-4.231 9.45-9.45 0-5.22-4.231-9.45-9.45-9.45zM2.45 14C2.45 7.621 7.62 2.45 14 2.45c6.379 0 11.55 5.171 11.55 11.55 0 6.379-5.171 11.55-11.55 11.55-6.379 0-11.55-5.171-11.55-11.55z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4D4D4D",
    fillRule: "evenodd",
    d: "M5.834 5.834c.41-.41 1.075-.41 1.485 0l14.847 14.847c.41.41.41 1.075 0 1.485-.41.41-1.075.41-1.485 0L5.834 7.319c-.41-.41-.41-1.075 0-1.485z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutOfStock);
export default __webpack_public_path__ + "static/media/out_of_stock.b1e2f301f700aba6eea322fdb864a78b.svg";
export { ForwardRef as ReactComponent };